var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H19V6H5V8ZM20 9.2V15.8H22V9.2H20ZM19 17H5V19H19V17ZM4 15.8V9.2H2V15.8H4ZM5 17C4.53527 17 4 16.5546 4 15.8H2C2 17.4755 3.25559 19 5 19V17ZM20 15.8C20 16.5546 19.4647 17 19 17V19C20.7444 19 22 17.4755 22 15.8H20ZM19 8C19.4647 8 20 8.44543 20 9.2H22C22 7.52451 20.7444 6 19 6V8ZM5 6C3.25559 6 2 7.52451 2 9.2H4C4 8.44543 4.53527 8 5 8V6Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5528 11.7764L11.1056 12.6708L11.5528 11.7764ZM12.4472 11.7764L12 10.882L12.4472 11.7764ZM3.55279 8.89443L11.1056 12.6708L12 10.882L4.44721 7.10557L3.55279 8.89443ZM12.8944 12.6708L20.4472 8.89443L19.5528 7.10557L12 10.882L12.8944 12.6708ZM11.1056 12.6708C11.6686 12.9523 12.3314 12.9523 12.8944 12.6708L12 10.882L11.1056 12.6708Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d029eecb36371cdd6018b18966a4b260.svg";
export { ForwardRef as ReactComponent };